import { CopyOutlined, GlobalOutlined, InfoCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { Switch, Tag, Tooltip, Typography, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { IVoucherEdit } from '../../api/voucher/voucherApi';
import { statusVoucher, statusVoucherDetail, typeReduced, typeVoucher, VoucherDetailStatusEnum } from '../../services/data';
import { formatDateToDMYGroup, formatPrice } from '../../until';
import './VoucherDetailCard.scss';
import { NO_DATA } from '../../env';


const { Text } = Typography;

type Props = {
  infoVoucher?: IVoucherEdit
  sLTypeVoucher: any[]
  onChangeActive?: (value: boolean) => void
};

const VoucherDetailCard: React.FC<Props> = ({ infoVoucher, sLTypeVoucher, onChangeActive }) => {



  async function copyTextToClipboard(text: any) {
    if ('clipboard' in navigator) return await navigator.clipboard.writeText(text);
    return document.execCommand('copy', true, text);
  }

  const handleCopyClick = (copyText: any) => {
    copyTextToClipboard(copyText).then(() => {
      message.success({ content: 'Copied', className: 'rs-message' });
    }).catch(console.log);
  }

  const statusLabel = statusVoucher.find(item => item.Value === Number(infoVoucher?.status))?.label;
  const reducedTypeLabel = typeReduced.find(item => item.Value === Number(infoVoucher?.percentDecrease ? 1 : 0))?.label;
  const voucherModelLabel = typeVoucher.find(item => item.Value === Number(infoVoucher?.type))?.label;
  const voucherTypeLabel = sLTypeVoucher.find(item => item.value === Number(infoVoucher?.typeVoucherId))?.label;

  const InfoRow = ({ label, value, valueEl }: { label: string; value?: React.ReactNode; valueEl?: React.ReactNode }) => (
    <div className="custom-page-css flex justify-between py-1 gap-6" >
      <span className="neutral-gray-500 text-nowrap text-sm">{label}</span>
      {valueEl ?? <span className="custom-page-css text-right text-sm text-344054">{value ?? '—'}</span>}
    </div>
  );

  const InfoRowDescription = ({ label, value }: { label: string; value?: React.ReactNode }) => (
    <div className="custom-page-css flex justify-between py-1 gap-6" >
      <span className="neutral-gray-500 text-nowrap text-sm">{label}</span>

      <div className='custom-page-css flex items-center gap-1'>
        <span className="custom-page-css text-right text-sm text-344054 text-truncate" style={{ width: '300px' }}>{value || NO_DATA}</span>

        {value &&
          <Tooltip
            placement="right"
            color="white"
            title={
              <div className="custom-page-css flex flex-col gap-2 p-2 "
              >

                <div
                  className=""
                >
                  <span className="custom-page-css text-sm text-344054" >{value}</span>
                </div>
              </div>
            }
          >
            <div className="count-number-E6F7FF">
              <InfoCircleFilled className="info-icon" />
            </div>
          </Tooltip>
        }
      </div>
    </div>
  );

  const InfoRowDetail = ({ label, }: { label: string }) => (
    <div className="custom-page-css flex justify-between py-1 gap-4" >
      <span className="neutral-gray-500 text-nowrap text-sm">{label}</span>
      {
        infoVoucher?.type === 1
          ?
          <div className='custom-page-css flex items-center gap-1'>
            <span className="custom-page-css text-right text-sm text-344054">{`${infoVoucher.totalGroups} nhóm khách hàng`}</span>
            <Tooltip
              placement="right"
              color="white"
              title={
                <div className="custom-page-css flex flex-col gap-2 p-2 scroll-tooltip-voucher"
                >
                  {
                    infoVoucher.voucherGroupCustomers.map((item, k) => (
                      <div
                        key={k}
                        className=""
                      >
                        <Text strong>{item.title}</Text>
                      </div>
                    ))
                  }
                </div>
              }
            >
              <div className="count-number-E6F7FF">
                <InfoCircleFilled className="info-icon" />
              </div>
            </Tooltip>
          </div>
          :
          infoVoucher?.type === 2
            ?
            <div className='custom-page-css flex items-center gap-1'>
              <span className="custom-page-css text-right text-sm text-344054">{`${infoVoucher.totalCustomers} khách hàng`}</span>
              <Tooltip
                placement="right"
                color="white"
                title={
                  <div className="custom-page-css flex flex-col gap-2 p-2 scroll-tooltip-voucher"
                  >
                    {
                      infoVoucher.voucherCustomers.map((item, k) => (
                        <div
                          key={k}
                          className=""
                        >
                          <Text strong>{item.title}</Text>
                        </div>
                      ))
                    }
                  </div>
                }
              >
                <div className="count-number-E6F7FF">
                  <InfoCircleFilled className="info-icon" />
                </div>
              </Tooltip>
            </div>
            :
            <span className="custom-page-css text-right text-sm text-344054">Toàn bộ khách hàng</span>

      }

    </div>
  );



  const renderStatusVoucherDetail = (type: number) => {
    switch (type) {
      case VoucherDetailStatusEnum.DRAFT:

        return (
          <div className='custom-page-css flex items-center gap-1 border-r pr-2'>
            <span className='h-6-px w-6-px custom-page-css rounded-full bg-CACACA'></span>
            <span>{statusVoucherDetail.find(item => item.value === type)?.title}</span>
          </div>
        )
      case VoucherDetailStatusEnum.AWAITING_APPROVAL:

        return (
          <div className='custom-page-css flex items-center gap-1 border-r pr-2'>
            <span className='h-6-px w-6-px custom-page-css rounded-full bg-FAAD14'></span>
            <span>{statusVoucherDetail.find(item => item.value === type)?.title}</span>
          </div>
        )
      case VoucherDetailStatusEnum.AWAITING_ACTIVATION:

        return (
          <div className='custom-page-css flex items-center gap-1 border-r pr-2'>
            <span className='h-6-px w-6-px custom-page-css rounded-full bg-1890FF'></span>
            <span>{statusVoucherDetail.find(item => item.value === type)?.title}</span>
          </div>
        )
      case VoucherDetailStatusEnum.ACTIVE:

        return (
          <div className='custom-page-css flex items-center gap-1 border-r pr-2'>
            <span className='h-6-px w-6-px custom-page-css rounded-full bg-2F54EB'></span>
            <span>{statusVoucherDetail.find(item => item.value === type)?.title}</span>
          </div>
        )
      case VoucherDetailStatusEnum.PAUSED:

        return (
          <div className='custom-page-css flex items-center gap-1 border-r pr-2'>
            <span className='h-6-px w-6-px custom-page-css rounded-full bg-D46B08'></span>
            <span>{statusVoucherDetail.find(item => item.value === type)?.title}</span>
          </div>
        )
      case VoucherDetailStatusEnum.REJECTED:

        return (
          <div className='custom-page-css flex items-center gap-1 border-r pr-2'>
            <span className='h-6-px w-6-px custom-page-css rounded-full bg-EC2D30'></span>
            <span>{statusVoucherDetail.find(item => item.value === type)?.title}</span>
          </div>
        )
      default:
        return (
          <div className='custom-page-css flex items-center gap-1 border-r pr-2'>
            <span className='h-6-px w-6-px custom-page-css rounded-full bg-52C41A'></span>
            <span>{statusVoucherDetail.find(item => item.value === type)?.title}</span>
          </div>
        )
    }
  }

  return (
    <div className="custom-page-css flex gap-4 border p-4 rounded relative bg-card-voucher-detail">
      <Switch
        value={infoVoucher?.status === VoucherDetailStatusEnum.ACTIVE ? true : false}
        className="custom-page-css rs-switch rs-switch--sm pt-3 flex-shrink-0"
        onChange={(e) => onChangeActive?.(e)}
      />

      <div className="custom-page-css w-full flex flex-col gap-2 relative z-100">
        {/* Row 1: code + status + title */}
        <div className="custom-page-css flex gap-2 items-center flex-wrap">
          <GlobalOutlined className="neutral-gray-400" />
          <span className="custom-page-css neutral-gray-400 border-r pr-2">Mã Voucher #{infoVoucher?.code}</span>
          {/* <CopyOutlined
            className="primary-7 cursor-pointer"
            onClick={() => handleCopyClick(infoVoucher?.code)}
          /> */}
          {/* <Tag className="rs-tag daybreak-blue">{statusLabel}</Tag> */}
          {renderStatusVoucherDetail(Number(infoVoucher?.status))}
          <span className="font-medium fsz-16">{infoVoucher?.title}</span>
        </div>

        {/* Row 2: description */}
        <div className="neutral-gray-500">
          {infoVoucher?.description || 'Đây là mô tả về chương trình voucher'}
        </div>

        {/* Row 3: group tags */}
        {(infoVoucher?.voucherGroupCustomers?.length ?? 0) > 0 && (
          <div className="custom-page-css flex gap-2 flex-wrap">
            {infoVoucher!.voucherGroupCustomers.map(g => (
              <Tag key={g.id} style={{ background: '#E6F4FF', color: '#1677ff', border: 'none', borderRadius: 4 }}>
                {g.title}
              </Tag>
            ))}
          </div>
        )}

        {/* Row 4: two-column info */}
        <div className="custom-page-css flex gap-8 pt-2">
          {/* Left column */}
          <div className="custom-page-css flex flex-col flex-1">
            <InfoRow label="Đơn vị phát hành" value={infoVoucher?.issuedUnit?.name} />
            <InfoRow label="Đơn vị áp dụng" value={infoVoucher?.appliedUnits} />
            <InfoRow label="Thương hiệu áp dụng" value={infoVoucher?.appliedBrands} />
            <InfoRow label="Hoạt động áp dụng" value={infoVoucher?.appliedActivities} />
            <InfoRow label="Loại hình" value={voucherModelLabel} />
            <InfoRow label="Loại voucher" value={voucherTypeLabel} />
            <InfoRowDetail label="Áp dụng cho" />
            <InfoRow label="Số lượng Voucher phát hành" value={formatPrice(infoVoucher?.quantity)} />
            <InfoRow label="Số lượng Voucher đã phát hành" value={formatPrice(infoVoucher?.releasedQuantity)} />
            <InfoRow label="Số lượng Voucher chưa phát hành" value={formatPrice(infoVoucher?.unreleasedQuantity)} />
            <InfoRow label="Số lượng Voucher đã quy đổi" value={formatPrice(infoVoucher?.redeemedVoucherQuantity)} />
            {
              infoVoucher?.status !== VoucherDetailStatusEnum.DRAFT && infoVoucher?.status !== VoucherDetailStatusEnum.AWAITING_APPROVAL &&
              <InfoRowDescription
                label="Ghi chú phê duyệt"
                value={infoVoucher?.approvalNote || ''}
              />
            }
          </div>
          {/* Right column */}
          <div className="custom-page-css flex flex-col flex-1">
            <InfoRow label="Đơn vị duyệt chương trình voucher" value={infoVoucher?.approvedUnit?.name} />
            <InfoRow
              label="Hình thức giảm"
              valueEl={<Tag className="rs-tag polar-green">{reducedTypeLabel}</Tag>}
            />
            <InfoRow
              label="Phần trăm/ Số tiền giảm"
              value={
                infoVoucher?.role === 1
                  ? `${infoVoucher.percentDecrease}%`
                  : infoVoucher?.reducedAmount
                    ? `${formatPrice(infoVoucher.reducedAmount)} đ`
                    : ''
              }
            />
            <InfoRow
              label="Số lần áp dụng cho mỗi khách hàng"
              value={infoVoucher?.usageCount ? `${infoVoucher.usageCount} lần` : ''}
            />
            <InfoRow
              label="Giá trị đơn hàng tối thiểu"
              value={infoVoucher?.orderValueMin ? `${formatPrice(infoVoucher.orderValueMin)} đ` : 'Không xác định'}
            />
            <InfoRow
              label="Số tiền giảm tối đa"
              value={infoVoucher?.reducedAmountMaximum ? `${formatPrice(infoVoucher.reducedAmountMaximum)} đ` : 'Không xác định'}
            />
            <InfoRow
              label="Thời gian bắt đầu"
              value={infoVoucher?.timeStart && infoVoucher?.dateStart ? `${infoVoucher.timeStart} ${formatDateToDMYGroup(infoVoucher.dateStart)}` : ''}
            />
            <InfoRow label="Thời gian bắt đầu thực tế" value={infoVoucher?.actualStartTime || ''} />
            <InfoRow
              label="Thời gian hết hiệu lực"
              value={infoVoucher?.timeEnd && infoVoucher?.dateEnd ? `${infoVoucher.timeEnd} ${formatDateToDMYGroup(infoVoucher.dateEnd)}` : ''}
            />
            <InfoRowDescription
              label="Điều kiện"
              value={infoVoucher?.termsOfUse || ''}
            />

          </div>
        </div>
      </div>

      <img src="/images/brand-icon--180x120.svg" alt="" className="custom-page-css absolute bottom-0 right-0 opacity-10" />
    </div>
  );
}

export default VoucherDetailCard;
